<template>
  <section class="document-form">
    <div class="form-item">
      <span>Policyholder HKID</span>
      <file-container
        :edit="true"
        :fileData="formData.id_type_pic"
        :otherData="{
          target: 'id_type_pic'
        }"
        titleName= "Policyholder HKID"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div>
    <div
      v-for="(item,index) in formData.nm_traveler_list"
      :key="index"
      class="form-item">
      <span>Traveller  {{index+1}}</span>
      <file-container
        :edit="true"
        :fileData="{
          url:item.id_type_pic_url,
          client_name:item.id_type_pic_path_id
        }"
        :otherData="{
          index,
          target: 'nm_traveler_list'
        }"
        titleName= "Traveller"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div>
    <!-- <div
      v-if="form.cust_typ == 2"
      class="form-item">
      <span>Certificate of Incorporation</span>
      <file-container
        :edit="true"
        :fileData="formData.cert_of_inc_pic"
        :otherData="{
          target: 'cert_of_inc_pic'
        }"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div> -->
  </section>
</template>
<script>
export default {
  name: 'TravelDocumentForm',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      formData: {
        id_type_pic: {},
        contract: {},
        // cert_of_inc_pic: {},
        other_file: [],
        nm_traveler_list:[]
      }
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        //todo
        if(JSON.stringify(val) != '{}') {
          if(this.formDataLock !== this.oldFormDataLock) {
            // 觸發更新就賦值，避免二次更新
            this.oldFormDataLock = this.formDataLock
            Object.keys(this.formData).some(key => {
              if(key in val) {
                this.formData[key] = JSON.parse(JSON.stringify(val[key]))
              }
            })
          }
        }
      }
    }
  },
  methods: {
    submitForm() {
      const { id_type_pic, contract } = this.formData
      let params = JSON.parse(JSON.stringify(this.formData))
      if(id_type_pic) {
        params.id_type_pic_path = id_type_pic.path
        params.id_type_pic_path_id = id_type_pic.id
      }
      return params
    },
    handlerDeleteFile(otherData) {
      const { target, index = '' } = otherData
      if(index === '') {
        this.formData[target] = null
      } else {
        this.formData[target].splice(index, 1)
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, type, index = '' } = otherData
      if(type === 'other') {
        if(!this.formData[target]) {
          this.formData[target] = []
        }
        this.formData[target].push(data)
      }
      else if(index === '') {
        this.$set(this.formData, target, data)
      } else {
        this.$set(this.formData[target], index, data)
      }
    }
  }
}
</script>